import { useEffect, useState } from 'react';

const SortAndFilterStocks = ({
  stockInfo,
  sortCriterion,
  filters,
  selectedIndicators,
  onProcessingComplete, // Callback to send sorted stocks to the parent
  onLoadingChange // Callback to control the loading bar in the parent
}) => {
 

  const filterStocks = (symbol) => {
    const rank = parseFloat(getStockInfo1(symbol, 'rank')) || 0;
    const strongBuy = parseFloat(getStockInfo2(symbol, 'strongBuy')) || 0;
    const buy = parseFloat(getStockInfo2(symbol, 'buy')) || 0;
    const volume = parseFloat(getStockInfo1(symbol, 'volume')) || 0;
    const news = getStockInfo1(symbol, 'news_data');
    const dailyIndicators = getStockInfo1(symbol, 'daily_conditions_satisfied') || [];
    const hourlyIndicators = getStockInfo1(symbol, 'hourly_conditions_satisfied') || [];

    const containsKeyword =
      !filters.newsKeyword ||
      (Array.isArray(news) &&
        news.some((article) =>
          article.summary.toLowerCase().includes(filters.newsKeyword.toLowerCase())
        ));

    const isUndervalued = filters.undervalued
      ? parseFloat(getStockInfo3(symbol, 'undervalues_stocks')) > 0
      : true;

    // const matchesPatterns =
    //   selectedPatterns.length === 0 ||
    //   selectedPatterns.every((pattern) => {
    //     const patternsInfo = getStockInfo1(symbol, 'patterns');
    //     return patternsInfo[pattern];
    //   });

    const matchesDailyIndicators =
    selectedIndicators.daily.length === 0 ||
    selectedIndicators.daily.every((indicator) => dailyIndicators.includes(indicator));

    const matchesHourlyIndicators =
    selectedIndicators.hourly.length === 0 ||
    selectedIndicators.hourly.every((indicator) => hourlyIndicators.includes(indicator));

    return (
      (!filters.strongBuy || strongBuy > parseFloat(filters.strongBuy)) &&
      (!filters.buy || buy > parseFloat(filters.buy)) &&
      (!filters.volume || volume > parseFloat(filters.volume)) &&
      (!filters.rank || rank > parseFloat(filters.rank)) &&
      containsKeyword &&
      isUndervalued &&
    //   matchesPatterns &&
      matchesDailyIndicators &&
      matchesHourlyIndicators
    //   matchesSearchTerm(symbol)
    );
  };

  

  const companiesWithAllData = (symbol) => {
    return (
      getStockInfo1(symbol, 'dividendRate') !== 'N/A' &&
      getStockInfo1(symbol, 'marketCap') !== 'N/A' &&
      getStockInfo1(symbol, 'volume') !== 'N/A' &&
      getStockInfo1(symbol, 'forward_pe') !== 'N/A' &&
      getStockInfo1(symbol, 'trailing_pe') !== 'N/A' &&
      getStockInfo1(symbol, 'forwardEps') !== 'N/A' &&
      getStockInfo1(symbol, 'trailingEps') !== 'N/A' &&
      getStockInfo1(symbol, 'earningsGrowth') !== 'N/A'
    );
  };

//   const getStockInfo = (symbol, changeType) => {
//     const change = dailyChanges.find(change => change.symbol === symbol);
//     return change ? (change[changeType] !== 'N/A' ? change[changeType]?.toFixed(2) + '%' : 'N/A') : 'N/A';
//   };

  const getStockInfo1 = (symbol, changeType) => {
    const change = stockInfo.find(change => change.symbol === symbol);
    if (change) {
      const value = change[changeType];
      return isValidNumber(value) ? value.toFixed(2) : value;
    }
    return 'N/A';
  };

  
//   const matchesSearchTerm = (symbol) => {
//     const companyName = getStockInfo1(symbol, 'company_name').toLowerCase();
//     const lowerCaseSymbol = symbol.toLowerCase();
//     const lowerCaseSearchTerm = searchTerm.toLowerCase();

//     return lowerCaseSymbol.includes(lowerCaseSearchTerm) || companyName.includes(lowerCaseSearchTerm);
//   };

  const getStockInfo2 = (symbol, changeType) => {
    const change = stockInfo.find(change => change.symbol === symbol);
    if (change) {
      const value = change['recommendations'][changeType];
      return isValidNumber(value) ? value.toFixed(2) : value;
    }
    return 'N/A';
  };

  const getStockInfo3 = (symbol, changeType) => {
    const change = stockInfo.find(change => change.symbol === symbol);
    if (change) {
      const target_low = change['target_low'];
      const target_high = change['target_high'];
      const target_mean = change['target_mean'];
      const current_price = change['current_price'];
      const value = (target_low - current_price)/current_price
      return isValidNumber(value) ? value.toFixed(2) : value;
    }
    return 'N/A';
  };

  const getStockInfo4 = (symbol, changeType) => {
    const change = stockInfo.find(change => change.symbol === symbol);
    if (change) {
      const value = change['options_diff'][changeType];
      return isValidNumber(value) ? value.toFixed(2) : value;
    }
    return 'N/A';
  };

  useEffect(() => {

    const processStocks = async () => {
      onLoadingChange(true); // Start loading

      if (stockInfo.length > 0) {
        const filteredStocks = stockInfo.filter(
          ({ symbol }) => filterStocks(symbol) 
        );

        const sortedStocks = filteredStocks.sort((a, b) => {
          const valueA = getCriterionValue(a.symbol);
          const valueB = getCriterionValue(b.symbol);

          // Handle undefined or 'N/A' values properly
          if (valueA === 'N/A' || valueA === undefined) return 1;
          if (valueB === 'N/A' || valueB === undefined) return -1;

          // Sort in descending order (higher value first)
          return valueB - valueA;
        });

        // Send sorted stocks to the parent
        onProcessingComplete(sortedStocks);
      }

      onLoadingChange(false); // Stop loading
    };

    processStocks();
  }, [  stockInfo,sortCriterion,filters,selectedIndicators,onProcessingComplete,onLoadingChange ]);



  const isValidNumber = (value) => typeof value === 'number' && !isNaN(value);

  const getCriterionValue = (symbol) => {
    // if (['daily_change', 'three_day_change', 'one_week_change', 'one_month_change'].includes(sortCriterion)) {
    //   return parseFloat(getStockInfo(symbol, sortCriterion)) || 0;
    // } 
    if (['strongBuy', 'buy'].includes(sortCriterion)) {
      return parseFloat(getStockInfo2(symbol, sortCriterion)) || 0;
    } 

    if (['undervalues_stocks'].includes(sortCriterion)) {
      return parseFloat(getStockInfo3(symbol, sortCriterion)) || 0;
    } 

    if (['call_volume_diff','call_openinterest_diff'].includes(sortCriterion)) {
      return parseFloat(getStockInfo4(symbol, sortCriterion)) || 0;
    } 
    
    else {
      return parseFloat(getStockInfo1(symbol, sortCriterion)) || 0;
    }
  };

  return null;
}

export default SortAndFilterStocks;
